import { render, staticRenderFns } from "./learningReport2.vue?vue&type=template&id=777641d4&scoped=true"
import script from "./learningReport2.vue?vue&type=script&lang=js"
export * from "./learningReport2.vue?vue&type=script&lang=js"
import style0 from "./learningReport2.vue?vue&type=style&index=0&id=777641d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777641d4",
  null
  
)

export default component.exports